import { create } from 'zustand';
import { persist } from 'zustand/middleware';

interface ThemeStore {
  isDarkMode: boolean;
  toggleDarkMode: () => void;
  setDarkMode: (isDark: boolean) => void;
}

export const useThemeStore = create<ThemeStore>()(
  persist(
    (set) => ({
      isDarkMode: false,
      toggleDarkMode: () => {
        set((state) => {
          const newIsDarkMode = !state.isDarkMode;
          updateDOMTheme(newIsDarkMode);
          return { isDarkMode: newIsDarkMode };
        });
      },
      setDarkMode: (isDark: boolean) => {
        set({ isDarkMode: isDark });
        updateDOMTheme(isDark);
      },
    }),
    {
      name: 'theme-storage',
      onRehydrateStorage: () => (state) => {
        if (!state) return;

        // Be strict: "false" (string) should NOT enable dark mode.
        const raw = (state as unknown as { isDarkMode?: unknown }).isDarkMode;
        const isDark = raw === true || raw === 'true' || raw === 1;
        state.setDarkMode(isDark);
      },
    }
  )
);

function updateDOMTheme(isDark: boolean) {
  const htmlElement = document.documentElement;
  if (isDark) {
    htmlElement.classList.add('dark');
  } else {
    htmlElement.classList.remove('dark');
  }
}

